import { parse, isValid } from 'date-fns';
import enUs from 'date-fns/locale/en-US';
import { Auth } from 'aws-amplify';
import { useTheme, useMediaQuery } from '@mui/material';



export function isValidDate(datestr) {    
    // console.log("isValidDate", datestr, isValid(parse(datestr, 'P', new Date(), { locale: enUs })));
    return isValid(parse(datestr, 'P', new Date(), { locale: enUs }));
}


export function longestCommonSubstring(src, tgt) { 
    let n = src.length; 
    let m = tgt.length; 
  
    let lcs = []; 
    for (let i = 0; i <= n; i++) { 
        lcs[i] = []; 
        for (let j = 0; j <= m; j++) { 
            lcs[i][j] = 0; 
        } 
    } 
  
    let lcsStart = 0;
    let lcsEnd = 0; 
    let max = 0; 
    for (let i = 0; i < n; i++) { 
        for (let j = 0; j < m; j++) { 
            if (src[i] === tgt[j]) { 
                lcs[i + 1][j + 1] = lcs[i][j] + 1; 
                if (lcs[i + 1][j + 1] > max) { 
                    max = lcs[i + 1][j + 1]; 
                    lcsStart = i - max + 1
                    lcsEnd = i + 1; 
                } 
            } 
        } 
    } 
  
    return [lcsStart, lcsEnd]; 
}

export function longestPrefixInString(src, tgt, ignoreTags = false) {
    
    for (let i = Math.min(tgt.length, src.length); i > 0; i--) {
        let within_tag = false;
        for (let j = 0; j < src.length; j++) {   
            if (ignoreTags) {
                // @@@ckl This is a hack because there may be legit situations where "<" or ">" are
                // part of the text, not an HTML tag.
                if (src[j] === '<') within_tag = true;
                if (src[j] === '>') within_tag = false;
                if (within_tag) continue;
            }
            
            if (src.substring(j, j+i) === tgt.substring(0, i))
                return [j, i];            
        }
    }
    return [-1, -1];
}

/**
 * Signs the user out and then redirects to the given URL.
 * @param {string} redirectUrl - The URL to redirect to after sign out.
 */
export async function signOutAndRedirect(redirectUrl, navigate) {
    try {
        await Auth.signOut();
    } catch (err) {
        console.error('Error signing out:', err);
    }

    if (navigate) {
        navigate(redirectUrl);
    } else {
        window.location.href = redirectUrl;
    }
}

// Utility hook to determine if the current screen size is mobile (down from 'md')
export function useIsMobile() {
    const theme = useTheme();
    return useMediaQuery(theme.breakpoints.down('lg'));
}
